import { Divider, Stack } from "@mui/material";
import { useSelector } from "react-redux";
import StyleGroup from "../../../../viewer/chart/StyleGroup.tsx";
import { selectChartSettingsState, selectValues } from "../../../../../store/selectors/fieldsStateSelectors.ts";
import SerieItem from "./SerieItem.tsx";

export default function SeriesStyles({ readonlyMode }: { readonlyMode: boolean }) {
  const settingsAreaValues = useSelector(selectChartSettingsState);
  const valuesAreaValues = useSelector(selectValues);

  return (
    <StyleGroup caption="Series">
      <Stack spacing={1} useFlexGap sx={{ width: "100%" }}>
        {settingsAreaValues.series?.map((serie, index) => {
          const lastSerie = settingsAreaValues.series?.length === index + 1;
          const serieItem = (
            <SerieItem
              key={serie.name}
              settings={settingsAreaValues}
              values={valuesAreaValues}
              serie={serie}
              readonlyMode={readonlyMode}
            />
          );
          if (!lastSerie) {
            return [serieItem, <Divider key={`Divider_${serie.name}`} sx={{ borderStyle: "dashed" }} />];
          }
          return serieItem;
        })}
      </Stack>
    </StyleGroup>
  );
}
